'use client';

import { IConsultation } from '@sapientpro/sapientpro-data-models';
import classnames from 'classnames';
import React from 'react';
import dynamic from 'next/dynamic';
import AnimatedTitle from '../../../components/AnimatedTitle';
import styles from './Consultation.module.scss';
import AltView from './AltView';
import ConsultationForm, { SubmitType } from './ConsultationForm';

const GradientCircles = dynamic(() => import('../../../components/GradientCircles'), {
  ssr: false,
});

type ConsultationProps = {
  data: IConsultation,
  className?: string,
  homepageVersion?: boolean,
  formId?: string,
  id?: string,
  type?: SubmitType
};
export default function Consultation({
  data, className, homepageVersion, formId, id, type,
}: ConsultationProps) {
  if (type && type === SubmitType.NEWSLETTER) {
    return (
      <AltView
        title={data.title}
        description={data.description}
        formId={formId}
        className={className}
      />
    );
  }

  return (
    <section
      className={classnames(styles.consultation, className)}
      id={id}
    >
      <div className='container'>
        <div className={classnames(styles.content, {
          [styles.content_homepage]: homepageVersion,
        })}
        >
          <h2 className={classnames('sectionTitle', styles.title)}>
            <AnimatedTitle title={data?.title} />
          </h2>
          <p className={styles.text}>
            {data?.description}
          </p>
          <ConsultationForm
            type={type}
            formId={formId}
            className={className}
          />
        </div>
        <GradientCircles />
      </div>
    </section>
  );
}
